var msg: Translations = {
    "msg.form.invalidemail": "Email no válido o ausente",
    "msg.form.invalidrecipients": "Se ha producido un error. Ponte en contacto con la administración informando de lo siguiente: \"Destinatario de contacto no válido o ausente.\"",
    "msg.form.invalidtype": "Se ha producido un error. Póngase en contacto con la administración informando de lo siguiente: \"Tipo de contacto inválido o faltante.\"",
    DELETEALLPRODUCTSERROR: 'Error removing products from cart',
    ERR_CARRIERMISSING: 'Antes tienes que seleccionar un tipo de envío.',
    ERR_CARRIER_COST_MISSING: 'Costos del transportador no disponibles por el país seleccionado y por el peso del pedido',
    ERR_CLIENTMANDATORYFIELDS: 'Rellena todos los campos obligatorios',
    ERR_DATE_FROM: "Date must be after :from",
    ERR_DATE_FROM_TO: "Date must be between :from and :to",
    ERR_DATE_TO: "Date must be before :to",
    ERR_FILE_TOO_LARGE: "El archivo es demasiado grande (tamaño máximo: :size)",
    ERR_FILLEMAILFIELD: 'Rellena los campos del correo electrónico.',
    ERR_INVALIDMAIL: 'Correo electrónico no valido.',
    ERR_LIGHTBOX_LOADING: 'Image detail is loading, try again in a few seconds',
    ERR_LOGININVALID: 'Correo electrónico o contraseña no validos',
    ERR_LOGINREQUIRED: 'Login solicitado',
    ERR_MISSINGFIELDS: 'Rellena todos los campos obligatorios.',
    ERR_NOSIZESELECTED: 'Tienes que seleccionar la talla',
    ERR_PEC_OR_SDI: 'Fill in at least one of PEC and SDI',
    ERR_PHONE_FORMAT_GENERIC: "Número de teléfono no válido",
    ERR_PHONE_FORMAT_INVALID_COUNTRY: "País no válido",
    ERR_PHONE_FORMAT_NOT_A_NUMBER: "Sólo puede contener caracteres numéricos",
    ERR_PHONE_FORMAT_TOO_LONG: "Número de teléfono demasiado largo",
    ERR_PHONE_FORMAT_TOO_SHORT: "Número de teléfono demasiado corto",
    ERR_PRIVACY: 'Para continuar debes aceptar las condiciones.',
    ERR_USEREXISTS: 'Usuario existente.',
    ERR_VAT: 'Incorrect VAT format',
    ERR_VAT_PREFIX: 'VAT must begin with country code (e.g. IT, FR)',
    ERR_ZIP_FORMAT: "",
    LABEL_ALREADYREGISTEREDUSERES: 'Already registered users',
    LABEL_ARTICLES: 'artículos',
    LABEL_CANCEL: 'Cancel',
    LABEL_CONFIRM: 'Confirm',
    LABEL_INVITES_ALREADY_SENT: 'Users already invited',
    LABEL_NOTAPPLICABLE: 'No aplicable',
    LABEL_NOTSENTINVITES: 'Unsent invites',
    LABEL_SELECTALL: 'Select all',
    LABEL_SENTINVITES: 'Sent invites',
    LABEL_SUBMIT: 'Submit',
    LABEL_WARNING: 'Aviso',
    MSG_ADDEDTOCART: 'Productos añadidos a tu carro',
    MSG_ADDED_TO_WISHLIST: 'Producto añadido a tu lista de deseos',
    MSG_APPLIEDVATCHANGED: 'After billing data upgrade, VAT applied to your order changed. Check the new amount once page gets reloaded',
    MSG_COUPON_ERROR: 'The coupon code inserted is not valid or has been already burned',
    MSG_COUPON_VALID: 'The coupon code inserted has been accepted successfully',
    MSG_DEFERRED_DISPATCH_COMPUTATION: 'Solamente los pedidos reservados serán habilitados y los costos de la entrega serán escritos a trevés de correo electrónico.',
    MSG_DELETEALLPRODUCTS: 'Are you sure you want to remove all products from the cart?',
    MSG_EXTRAUELIMIT: 'La cifra m�nima de su pedido no puede ser inferior a 2000.00 &euro,',
    MSG_GENERIC_ERROR: 'Lo siento, hay un error. ',
    MSG_INSUFFICIENT_STOCK: 'Lo siento, en este momento no tenemos suficientes productos disponibles.',
    MSG_INVALID_CAPTCHA: 'Invalid captcha code',
    MSG_MAILSENT: 'E-Mails enviados',
    MSG_MESSAGE_PRODUCTSHARE: 'Mensaje',
    MSG_CONTACT_SENT: 'Message sent successfully!',
    MSG_MESSAGE_SENT: 'Message sent successfully!',
    MSG_MIXED_CART: 'El producto que quieres añadir se encuentra en un diferente almacén, por lo tanto tienes que crear otro pedido.',
    MSG_MIXED_INTANGIBLE: 'En el carro hay productos que pertenecen a una venta que no pueden estar en el carro juntos a este producto.',
    MSG_MUST_ACCEPT_TERMS: 'You must accept the terms of use',
    MSG_NEWSLETTER_COMPLETED: 'Successful registration',
    MSG_PASSWORD_NOT_COMPLEX: 'Password must include at least 1 uppercase character, 1 lowercase character and 1 number and be at least 8 characters long',
    MSG_PASSWORD_NOT_EQUAL: 'La nueva contraseña y la contraseña de confirmación no coinciden',
    MSG_PASSWORD_OK: 'Contraseña cambiada con éxito',
    MSG_PASSWORD_RESET: 'Password was succesfully reset',
    MSG_PAYMENT_PENDING: 'Pago pendiente',
    MSG_PRIVACY_POLICY: 'You must accept the privacy policy',
    MSG_PROFILECONSENT_SAVED: 'Tus preferencias de contacto han sido actualizadas',
    MSG_RECOVEREMAILSENT: 'Revisa tu correo electrónico y haz clic sobre el enlace para confirmar el cambio.',
    MSG_RECOVEREMAILSENT_ERROR: 'Atención: no estás registrado con esta dirección de correo electrónico o ya está restableciendo su contraseña.',
    MSG_REMOVED_FROM_WISHLIST: 'Product removed from your wishlist',
    MSG_RETURN_REQUEST: 'Return request created successfully',
    MSG_RETURN_REQUEST_ERROR: 'Return request could not be created, contact the admin',
    MSG_RETURN_REQUEST_SUCCESS: 'Return Request created successfully',
    MSG_RULE_REJECT: 'Product cannot be added to cart because of rule :rule',
    MSG_SAVE_SUCCESS: 'Save successful',
    MSG_SELECT_PROVINCE: "Select a province",
    MSG_SENDER_PRODUCTSHARE: 'Tu nombre',
    MSG_SUBJECT_PRODUCTSHARE: ' compartir algo contigo',
    MSG_SUBSCRIBED: 'Registrado con éxito',
    MSG_SUBSCRIPTION_FAILURE: 'Make sure you do not have any other active subscription',
    MSG_SUBSCRIPTION_NO_RENEWABLE: 'Pasaron demasiados días y por eso la suscripción no es renovable',
    MSG_TOKEN_SENT: 'We have sent a verification code to your e-mail address. Check that you have received our message and input the code',
    MSG_USER_ALREADY_REGISTERED: 'User is already registered',
    MSG_USER_NOT_FOUND: 'User not found',
    MSG_WAIT: 'Espera por favor...',
    MSG_WRONG_PASSWORD: 'Wrong password'
}


